// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".case-referral-history .flex-referral .edit-modal__icon .edit-modal__text{color:#4467ab !important;text-transform:none;visibility:visible}.case-referral-history .flex-referral .edit-modal__icon .ui-icon.mt-quarter{margin-top:unset;fill:#4467ab}", ""]);
// Exports
module.exports = exports;
